import { render, staticRenderFns } from "./BaseRichTextarea.vue?vue&type=template&id=39db4e6c&"
import script from "./BaseRichTextarea.vue?vue&type=script&lang=ts&"
export * from "./BaseRichTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports